document.addEventListener("DOMContentLoaded", function () {
    const gallery = document.querySelector(".js-product-gallery");
    if (!gallery) return;

    // ------------------------------------
    // INITIAL VARIANT FROM URL HANDLING
    // ------------------------------------
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromURL = urlParams.get("variant");

    let initialIndex = 0; // default

    // --- If variant exists in URL, compute its corresponding media index ---
    if (variantFromURL && window.product) {

        const variant = window.product.variants.find(v => v.id == variantFromURL);

        if (variant && variant.featured_media) {
            const targetMediaId = variant.featured_media.id;

            const cells = [...gallery.querySelectorAll(".carousel-cell")];

            const index = cells.findIndex(
                cell => cell.dataset.mediaId == targetMediaId
            );

            if (index >= 0) {
                initialIndex = index; // set before Flickity init
            }
        }
    }

    document.querySelectorAll(".hide_image").forEach(el => {
        el.style.display = "block";
    });
    // --- Now initialize Flickity with initialIndex ---
    const flkty = new Flickity(gallery, {
        cellAlign: "left",
        contain: true,
        wrapAround: true,
        lazyLoad: false,
        prevNextButtons: true,
        pageDots: false,
        initialIndex: initialIndex
    });

    /* -------------------------------
        VIDEO AUTOPLAY CONTROLS
    --------------------------------*/
    function controlVideos() {
        flkty.cells.forEach((cell, index) => {
        const video = cell.element.querySelector("video");
        if (!video) return;

        if (index === flkty.selectedIndex) {
            video.muted = true;
            video.play().catch(() => {});
        } else {
            video.pause();
            video.currentTime = 0;
        }
        });
    }

    controlVideos();
    flkty.on("change", controlVideos);

    /* --------------------------------
        VARIANT → JUMP TO MEDIA
    --------------------------------*/
    const variantSelect = document.querySelector("[name='id']");

    if (variantSelect) {
        variantSelect.addEventListener("change", function () {
        const selectedVariant = window?.product?.variants?.find(
            v => v.id == this.value
        );

        if (!selectedVariant || !selectedVariant.featured_media) return;

        const targetMediaId = selectedVariant.featured_media.id;

        const cells = [...gallery.querySelectorAll(".carousel-cell")];
        const targetIndex = cells.findIndex(cell => 
            cell.dataset.mediaId == targetMediaId
        );

        if (targetIndex >= 0) {
            flkty.select(targetIndex);
        }
        });
    }
});